module.exports = __webpack_public_path__ + "static/img/Jeremy_Howe_mobile.bb9a344.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeremy_Howe_mobile.jpg
// module id = 6HtU
// module chunks = 0